import { render, staticRenderFns } from "./ProductCardStarter.vue?vue&type=template&id=4fe38bf8&scoped=true&"
import script from "./ProductCardStarter.vue?vue&type=script&lang=ts&"
export * from "./ProductCardStarter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe38bf8",
  null
  
)

export default component.exports